import type { ThemeConfig } from 'antd';

export const limeTheme: ThemeConfig = {
  token: {
    colorPrimary: '#bedc79', colorInfo: '#71864a', colorSuccess: '#62863e', colorWarning: '#b48135', colorError: '#bd554a',
    colorText: '#242720', colorTextSecondary: '#777d70', colorBgLayout: '#f0f1ec', colorBgContainer: '#ffffff',
    colorBorder: '#e2e5db', colorBorderSecondary: '#edf0e7', colorLink: '#526c2f', colorLinkHover: '#263b0c',
    borderRadius: 12, borderRadiusLG: 22, controlHeight: 38, fontSize: 14,
    fontFamily: '"Avenir Next", "PingFang SC", "Microsoft YaHei", sans-serif',
    boxShadow: '0 12px 44px rgba(32, 40, 22, .08)',
  },
  components: {
    Button: { primaryColor: '#20251a', fontWeight: 550, defaultShadow: 'none', primaryShadow: 'none' },
    Card: { headerFontSize: 17, headerFontSizeSM: 15, bodyPadding: 24, bodyPaddingSM: 20 },
    Table: { headerBg: '#f5f6f1', headerColor: '#757c6b', rowHoverBg: '#f6f9ef', cellPaddingBlock: 17, cellPaddingInline: 18 },
    Tabs: { inkBarColor: '#95b956', itemSelectedColor: '#29331e', itemHoverColor: '#566c34' },
    Segmented: { trackBg: '#eef0e9', itemSelectedBg: '#fff', itemSelectedColor: '#22291c' },
    Tag: { defaultBg: '#f1f3ec', defaultColor: '#656d59' },
    Modal: { titleFontSize: 21, paddingContentHorizontalLG: 28 },
    Drawer: { paddingLG: 26 },
    Form: { labelColor: '#58614e', labelFontSize: 13 },
  },
};
